/*
    Loads a Javascript file and runs a callback onload.
*/

export default function loadScript(url, callback) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = "text/javascript";
    script.async = true;
    script.src = url;

    script.addEventListener('load', callback);

    head.appendChild(script);
}
